import { useEffect } from 'react';
import { lockWallet } from './wallet-seed';
import { isExtension } from './utils';

const IDLE_LOCK_MS = 10 * 60 * 1000;
// Grace after Cordova 'pause' so permission prompts and intents do not lock.
const BACKGROUND_GRACE_MS = 60 * 1000;
const ACTIVITY_EVENTS = ['mousedown', 'keydown', 'touchstart', 'scroll'];

// Locks on inactivity, on prolonged backgrounding, and when the extension
// background clears the session mnemonic.
export function useAutoLock() {
  useEffect(() => {
    let idleTimer;
    let pauseTimer;
    let pausedAt = null;

    const resetIdle = () => {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(lockWallet, IDLE_LOCK_MS);
    };
    const onPause = () => {
      pausedAt = Date.now();
      clearTimeout(pauseTimer);
      pauseTimer = setTimeout(lockWallet, BACKGROUND_GRACE_MS);
    };
    const onResume = () => {
      clearTimeout(pauseTimer);
      if (pausedAt !== null && Date.now() - pausedAt >= BACKGROUND_GRACE_MS) {
        lockWallet();
      }
      pausedAt = null;
      resetIdle();
    };
    // Mirror a background-side lock (alarm) into this page.
    const onStorage = (changes, area) => {
      const change = area === 'session' && changes.unlockedMnemonic;
      if (change && change.oldValue && !change.newValue) {
        lockWallet();
      }
    };

    resetIdle();
    ACTIVITY_EVENTS.forEach((event) =>
      window.addEventListener(event, resetIdle, { passive: true }),
    );
    document.addEventListener('pause', onPause, false);
    document.addEventListener('resume', onResume, false);
    if (isExtension) {
      chrome.storage.onChanged.addListener(onStorage);
    }

    return () => {
      clearTimeout(idleTimer);
      clearTimeout(pauseTimer);
      ACTIVITY_EVENTS.forEach((event) =>
        window.removeEventListener(event, resetIdle),
      );
      document.removeEventListener('pause', onPause, false);
      document.removeEventListener('resume', onResume, false);
      if (isExtension) {
        chrome.storage.onChanged.removeListener(onStorage);
      }
    };
  }, []);
}
